import React, { useState } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import { useSpring, animated } from "react-spring";
import FormControl from "@material-ui/core/FormControl";
import MailOutlineOutlinedIcon from "@material-ui/icons/MailOutlineOutlined";
import PhoneAndroidIcon from "@material-ui/icons/PhoneAndroid";
import ShortTextIcon from "@material-ui/icons/ShortText";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import Button from "@material-ui/core/Button";
import { CircularProgress } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { HOST_URL, basename } from "../../../config";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./scheduleSignUp.css";
import MainLayout from "../../common/Layout/MainLayout";
import routeConstant from "../../../route/compoent/routeConstant";

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: "1.5rem",
  },
}));

const Fade = React.forwardRef(function Fade(props, ref) {
  const { in: open, children, onEnter, onExited, ...other } = props;
  const style = useSpring({
    from: { opacity: 0 },
    to: { opacity: open ? 1 : 0 },
    onStart: () => {
      if (open && onEnter) {
        onEnter();
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited();
      }
    },
  });

  return (
    <animated.div ref={ref} style={style} {...other}>
      {children}
    </animated.div>
  );
});

Fade.propTypes = {
  children: PropTypes.element,
  in: PropTypes.bool.isRequired,
  onEnter: PropTypes.func,
  onExited: PropTypes.func,
};

function ScheduleSignup() {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [company, setCompany] = useState("");
  const [loading, setLoading] = useState(false);
  const [openalert, setOpenalert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [severity, setSeverity] = useState("error");
  const [open, setOpen] = useState(false);
  // const history = useHistory();

  const navigate = useNavigate();
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenalert(false);
  };

  const handleModalOpen = () => {
    setOpen(true);
  };

  const handleModalClose = () => {
    setOpen(false);
  };

  const letsLogin = () => {
    handleModalClose();
    navigate(routeConstant.SCHEDULE_LOGIN);
  };

  const signUp = () => {
    const fullName = name.trim();
    const emailAddress = email.trim();
    const companyName = company.trim();
    if (!fullName) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill your Full Name!");
    } else if (!/^[a-z][a-z\s]*$/i.test(fullName)) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill correct Full Name!");
    } else if (!number && !/^\d+$/.test(number)) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please enter valid Phone Number!");
    } else if (!emailAddress) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill your email address!");
    } else if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        emailAddress
      )
    ) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill correct email address!");
    } else if (!companyName) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill your Company name!");
    } else {
      setLoading(true);
      const URL = `${HOST_URL}api/v1/TempAccountData/AddorEditUser`;
      const params = {
        user_id: email,
        name_of_user: name,
        email: email,
        password: "",
        company_code: company,
        country_code: "",
        ActionName: "Add",
        Contact: number,
      };
      console.log(fullName);
      axios
        .post(URL, params)
        .then((res) => {
          setLoading(false);
          if (res.data === "2") {
            setOpenalert(true);
            setSeverity("warning");
            setAlertText("User already exist!");
          }
          if (res.data === "1") {
            handleModalOpen();
          }
          if (res.data === "0") {
            setOpenalert(true);
            setSeverity("warning");
            setAlertText("Invalid data");
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
          setOpenalert(true);
          setSeverity("error");
          setAlertText("Something went wrong!");
        });
    }
  };

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  return (
    <div className="scheduleSignUpComp">
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openalert}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert severity={severity} onClose={handleClose}>
          {alertText}
        </Alert>
      </Snackbar>
      <Modal
        className={classes.modal + " materialModalContainer"}
        open={open}
        // onClose={handleModalClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper + " materialModal"}>
            <div className="filterModeComponent singupSuccessModal">
              <div className="modalHeading">
                <h6>User Created Successfully!</h6>
              </div>
              <div className="filterModalBody">
                <p>
                  Username and Password successfuly <br />
                  sent to <span className="modalEmail">{email}</span>.
                </p>
              </div>
              <div className="modalFooter mt-3">
                <Button variant="contained" onClick={letsLogin}>
                  Go to Login!
                </Button>
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
      <div className="scheduleSignUpCompBody">
        <div className="scheduleSignUpCompBodyInner">
          <img
            src={`/${basename}/Assets/Images/mtslogo.svg`}
            alt="mtsFavIcon"
          />
          <div className="userId">
            <FormControl className={clsx(classes.margin, classes.textField)}>
              <TextField
                id="standard-basic"
                label={
                  <span className="loginLabelSpan">
                    <ShortTextIcon /> Enter your Full Name
                  </span>
                }
                value={name}
                type="text"
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </FormControl>
          </div>
          <div className="userId">
            <FormControl className={clsx(classes.margin, classes.textField)}>
              <TextField
                id="standard-basic"
                label={
                  <span className="loginLabelSpan">
                    <PhoneAndroidIcon /> Enter your Phone Number
                  </span>
                }
                value={number}
                type="tel"
                onChange={(e) => {
                  setNumber(e.target.value);
                }}
              />
            </FormControl>
          </div>
          <div className="userId">
            <FormControl className={clsx(classes.margin, classes.textField)}>
              <TextField
                id="standard-basic"
                label={
                  <span className="loginLabelSpan">
                    <MailOutlineOutlinedIcon /> Enter your email address
                  </span>
                }
                value={email}
                type="text"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
            </FormControl>
          </div>
          <div className="userId">
            <FormControl className={clsx(classes.margin, classes.textField)}>
              <TextField
                required
                id="standard-basic"
                label={
                  <span className="loginLabelSpan">
                    <LocationCityIcon /> Enter your Company name
                  </span>
                }
                value={company}
                type="text"
                onChange={(e) => {
                  setCompany(e.target.value);
                }}
              />
            </FormControl>
          </div>
          <div className="loginButton my-3">
            <Button variant="contained" onClick={() => signUp()}>
              {loading ? <CircularProgress size="1.5rem" /> : "Sign Up"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ScheduleSignup;
